import FeatureGates from '@atlaskit/feature-gate-js-client';

export const useGate = () => {
  const isFeatureEnabled = (name: string, defaultValue = false) => {
    try {
      return FeatureGates.checkGate(name);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return defaultValue;
    }
  };

  return isFeatureEnabled;
};
